import { render } from "./NavChild.vue?vue&type=template&id=ff93e3d8&ts=true"
import script from "./NavChild.vue?vue&type=script&lang=ts"
export * from "./NavChild.vue?vue&type=script&lang=ts"

import exportComponent from "G:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__